/**
 * 应用元信息
 * @module app/appMeta
 */

import pkg from '../../package.json';

export const appName = 'yiBlock2';
export const appFullName = '易联魔方智能物联网图形化编程平台';
export const appVersion = pkg.version;
